"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Spreadsheet = void 0;
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable react/jsx-no-bind */
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
var use_spreadsheet_1 = require("../hooks/use-spreadsheet");
var table_1 = require("../table");
var loading_more_indicator_1 = require("../table/loading-more-indicator");
var no_results_1 = require("../table/no-results");
var spreadsheet_cell_1 = require("../table/spreadsheet-cell");
var table_loading_body_1 = require("../table/table-loading-body");
var tbody_1 = require("../table/tbody");
function Spreadsheet(_a) {
    var data = _a.data, _b = _a.loading, loading = _b === void 0 ? false : _b, columns = _a.columns, _c = _a.rowsToShow, rowsToShow = _c === void 0 ? 8 : _c, heightProp = _a.height, _d = _a.rowHeight, rowHeight = _d === void 0 ? 80 : _d, tableOptions = _a.tableOptions, _e = _a.options, options = _e === void 0 ? {
        isEditable: false,
        hasFooter: false,
    } : _e, tableId = _a.tableId, onColumnClick = _a.onColumnClick, globalFilter = _a.globalFilter, _f = _a.state, state = _f === void 0 ? {} : _f, onSelectedRowIds = _a.onSelectedRowIds, onSort = _a.onSort, _g = _a.renderNoResults, renderNoResults = _g === void 0 ? no_results_1.NoResults : _g, propTestId = _a.testId, onScrollCenter = _a.onScrollCenter, _h = _a.isLoadingMore, isLoadingMore = _h === void 0 ? false : _h;
    // If we're loading more, add a dummy row to the end of the data so the loading indicator shows up
    var dataWithLoadingMore = isLoadingMore ? __spreadArray(__spreadArray([], data, true), [{ isDummyLoadingMoreItem: true }], false) : data;
    var _j = (0, use_spreadsheet_1.useSpreadsheet)({
        data: dataWithLoadingMore,
        columns: columns,
        height: heightProp,
        tableOptions: tableOptions,
        rowsToShow: rowsToShow,
        tableId: tableId,
        globalFilter: globalFilter,
        state: state,
        options: options,
        onSelectedRowIds: onSelectedRowIds,
        isRowSelectable: options.isRowSelectable,
        disableToggleAllSelected: options.disableToggleAllSelected,
        rowHeight: rowHeight,
        onScrollCenter: onScrollCenter,
    }), table = _j.table, virtual = _j.virtual, height = _j.height;
    var getTableProps = table.getTableProps, getTableBodyProps = table.getTableBodyProps, prepareRow = table.prepareRow, rows = table.rows, headerGroups = table.headerGroups, footerGroups = table.footerGroups, totalColumnsWidth = table.totalColumnsWidth;
    var outerRef = virtual.outerRef, innerRef = virtual.innerRef, items = virtual.items;
    var testId = propTestId !== null && propTestId !== void 0 ? propTestId : tableId;
    function handleCellClick(row, cellValue, columnId, cellIndex) {
        if (onColumnClick) {
            onColumnClick({ row: row, cellValue: cellValue, columnId: columnId, cellIndex: cellIndex });
        }
    }
    var hasResults = rows.length > 0;
    if (!hasResults && !loading) {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(table_1.Table, __assign({}, getTableProps(), { style: {
                    maxHeight: height,
                    minHeight: loading ? 300 : 'auto',
                }, testId: testId }),
                react_1.default.createElement(table_1.THead, { headerGroups: headerGroups, onSort: onSort, style: { minWidth: totalColumnsWidth }, testId: testId }),
                react_1.default.createElement(tbody_1.TBody, __assign({}, getTableBodyProps(), { style: { minWidth: totalColumnsWidth }, testId: testId }), renderNoResults()))));
    }
    if (loading) {
        return (react_1.default.createElement("div", null,
            react_1.default.createElement(table_1.Table, __assign({}, getTableProps(), { style: {
                    maxHeight: height,
                    minHeight: loading ? 300 : 'auto',
                }, testId: testId }),
                react_1.default.createElement(table_1.THead, { headerGroups: headerGroups, onSort: onSort, style: { minWidth: totalColumnsWidth }, testId: testId }),
                react_1.default.createElement(tbody_1.TBody, __assign({}, getTableBodyProps(), { style: { minWidth: totalColumnsWidth }, testId: testId }),
                    react_1.default.createElement(table_loading_body_1.TableLoadingBody, { ref: outerRef })))));
    }
    return (react_1.default.createElement(table_1.ScrollableTableContainer, { height: heightProp },
        react_1.default.createElement(table_1.Table, __assign({ testId: testId, isSelectable: !!onSelectedRowIds }, getTableProps(), { style: {
                maxHeight: heightProp ? '100%' : height,
                minHeight: loading || !hasResults ? 300 : 'auto',
            }, ref: outerRef }),
            react_1.default.createElement(table_1.THead, { headerGroups: headerGroups, onSort: onSort, style: {
                    minWidth: totalColumnsWidth,
                }, testId: testId }),
            react_1.default.createElement(tbody_1.TBody, __assign({}, getTableBodyProps(), { ref: innerRef, style: {
                    minWidth: totalColumnsWidth,
                }, testId: testId }), items.map(function (_a) {
                var _b;
                var index = _a.index, size = _a.size;
                var row = rows[index];
                if (!row) {
                    return null;
                }
                var isDummyLoadingMoreItem = 'isDummyLoadingMoreItem' in row.original && row.original.isDummyLoadingMoreItem;
                if (!isDummyLoadingMoreItem) {
                    prepareRow(row);
                }
                if (isLoadingMore && isDummyLoadingMoreItem) {
                    return (react_1.default.createElement(loading_more_indicator_1.LoadingMoreIndicator, { style: {
                            minHeight: size,
                        }, key: "loading-indicator" }));
                }
                return (react_1.default.createElement(table_1.Row, __assign({}, row.getRowProps({
                    style: {
                        minHeight: size,
                    },
                }), { "data-row-index": index, "data-row-id": row.id, testId: (0, core_ui_1.generateTestId)(testId, (_b = row.id) !== null && _b !== void 0 ? _b : row.index) }), row.cells.map(function (cell, index) { return (react_1.default.createElement(spreadsheet_cell_1.SpreadsheetCell, { key: cell.column.id, cell: cell, row: row, index: index, onCellClick: handleCellClick, testId: testId })); })));
            })),
            hasResults && options.hasFooter && !loading && react_1.default.createElement(table_1.TFoot, { footerGroups: footerGroups }))));
}
exports.Spreadsheet = Spreadsheet;
